// @ts-strict-ignore
import { authorizationRoles, authorize } from "app/utils/authorizationUtils";
import { showError } from "app/utils/notificationUtils";

const hasAnalyticsAccess = (user) => {
	if (!user || !user.roles || !user.roles.length) {
		showError("Insufficient user data!");
	} else {
		const userHasPremiumRole = authorize(
			user.roles,
			[
				authorizationRoles.SUPERADMIN,
				authorizationRoles.ADMIN,
				authorizationRoles.PREMIUMSUBSCRIBER
			]
		);

		if ((user.company?.subscriptionType === "combined" || user.company?.subscriptionType === "analytics") && userHasPremiumRole) {
			return true;
		}

		return false;
	}
};

export default hasAnalyticsAccess;
